<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin blueBg">
        <div class="inner">
            <h3>{{ $t('contact.edit.confirm') }}</h3>

            <div class="textBox">

                <form @submit.prevent="handleOnSubmit">
                    <div class="form-group row">
                        <label for="email" class="col-sm-4 col-form-label">{{ $t('contact.edit.selection') }}</label>
                        <div class="col-sm-8" id="email">{{ formData.selection }}</div>
                    </div>

                    <div class="form-group row">
                        <label for="subject" class="col-sm-4 col-form-label">{{ $t('contact.edit.subject') }}</label>
                        <div class="col-sm-8" id="subject">{{ formData.subject }}</div>
                    </div>

                    <div class="form-group row">
                        <label for="content" class="col-sm-4 col-form-label">{{ $t('contact.edit.content') }}</label>
                        <div class="col-sm-8 output" id="content">{{ formData.content }}</div>
                    </div>

                    <div class="text-center">
                        <div class="pb-4 pr-1">
                            <button type="button" class="btn btn-outline-primary mr-2 " v-on:click="$router.back()">
                                {{ $t('contact.edit.back') }}
                            </button>
                            <button type="submit" class="btn btn-primary ml-2">
                                {{ $t('contact.edit.send') }}
                            </button>
                        </div>
                    </div>

                </form>

            </div>
        </div>
    </div>
</template>


<script>
    import contactService from '../../services/ContactService';

    export default {
        name: 'contact-confirm-module',

        components: {
        },

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
            }
        },

        created() {
            this.formData = contactService.getLocalStorage()
        },

        methods: {
            getDefaultFields() {
                return {
                    selection: '',
                    subject: '',
                    content: '',
                };
            },

            handleOnFormClear() {
                this.formData = this.getDefaultFields();
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                const dataSends = contactService.getLocalStorage()

                try {
                    const result = await contactService.sendMail({
                        ...dataSends
                    });
                    this.$router.push('/contact/complate');
                } catch (err) {
                    if (err.response.data.errors) {
                        this.$router.push('/contact');
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .btn-primary {
        width: 70px;
    }
    .btn-outline-primary {
        width: 70px;
    }
    #content {
        white-space: pre-wrap;
        word-wrap: break-word;
    }
</style>
